import { Popover, Input, Button, Flex } from "antd";
import React, { useState } from "react";

type TableProps = {
  icon?: React.ReactNode;
  onClick: (columns: string, rows: string) => void;
};

const Table: React.FC<TableProps> = ({ icon, onClick }) => {
  const [visible, setVisible] = useState(false);
  const [rowValue, setRowValue] = useState("");
  const [colvalue, setColValue] = useState("");

  const handleIconClick = () => {
    setVisible(!visible);
  };

  const handleOk = () => {
    setVisible(false);
    if (rowValue && colvalue && onClick) {
      onClick(colvalue, rowValue);
    }
  };

  const handleColumn = (e: React.ChangeEvent<HTMLInputElement>) => {
    setColValue(e.target.value);
  };
  const handleRow = (e: React.ChangeEvent<HTMLInputElement>) => {
    setRowValue(e.target.value);
  };

  const content = (
    <Flex gap="small" vertical={true}>
      <Input
        type="small"
        placeholder={`Enter number of columns`}
        value={colvalue}
        onChange={handleColumn}
        onPressEnter={handleOk}
      />
      <Input
        type="small"
        placeholder={`Enter number of rows`}
        value={rowValue}
        onChange={handleRow}
        onPressEnter={handleOk}
      />

      <Button type="primary" onClick={handleOk} style={{ marginTop: "8px" }}>
        OK
      </Button>
    </Flex>
  );

  return (
    <Popover
      content={content}
      title={`Enter no of rows and columns`}
      open={visible}
      trigger="click"
      onOpenChange={(visible) => setVisible(visible)}
    >
      <Flex style={{ cursor: "pointer" }} onClick={handleIconClick}>
        {icon}{" "}
      </Flex>
    </Popover>
  );
};
export default Table;
